'use client'; // must be client-side component
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('App Error:', error);
  }, [error]);

  return (
    <main style={{ textAlign: 'center', padding: '4rem' }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Something went wrong</h1>
      <p style={{ fontSize: '1.25rem', color: '#555' }}>
        We encountered a server error (500). Please try again later.
      </p>
      <button
        onClick={() => reset()}
        style={{
          marginTop: '2rem',
          padding: '0.75rem 1.5rem',
          backgroundColor: '#0f62fe',
          color: '#fff',
          borderRadius: '4px',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Try again
      </button>
    </main>
  );
}
